import { render, staticRenderFns } from "./ReporteGestiones.vue?vue&type=template&id=498d6482&"
import script from "./ReporteGestiones.vue?vue&type=script&lang=js&"
export * from "./ReporteGestiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports